"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoanMechanics = void 0;
const getLoanMechanics = (loanMechanics, maturityDate, lenders, classes) => {
    // If not null, return original
    if (loanMechanics) {
        return { loanMechanics };
    }
    // Otherwise, create empty set, then enhance with defaults for commitments
    // Leave pricing options and loans empty
    const result = {
        loanMechanics: { pricingOptions: [], loans: [], commitments: [] },
    };
    // No loans configured (facility assumes single revolving line of credit)
    // Commitments add up to facility and class amounts
    // Global constraint
    result.loanMechanics.commitments.push({
        key: 'global',
        name: 'Global commitment',
        limit: {
            type: 'amount',
            amount: lenders.reduce((sum, lender) => sum + lender.commitment.amount, 0),
            currency: lenders[0].commitment.currency,
        },
        loans: [],
        maturityDate,
    });
    // Funding constraint(s) - multiple if classes are present
    if (classes) {
        for (const fundingClass of classes) {
            result.loanMechanics.commitments.push({
                key: fundingClass.key,
                name: `Class ${fundingClass.key}`,
                limit: {
                    type: 'amount',
                    amount: lenders
                        .filter((lender) => fundingClass.lenderIds.includes(lender.organizationId))
                        .reduce((sum, lender) => sum + lender.commitment.amount, 0),
                    currency: lenders[0].commitment.currency,
                },
                loans: [],
                maturityDate,
            });
        }
    }
    else {
        result.loanMechanics.commitments.push({
            key: 'facility',
            name: 'Facility',
            limit: {
                type: 'amount',
                amount: lenders.reduce((sum, lender) => sum + lender.commitment.amount, 0),
                currency: lenders[0].commitment.currency,
            },
            loans: [],
            maturityDate,
        });
    }
    return result;
};
exports.getLoanMechanics = getLoanMechanics;
//# sourceMappingURL=loans.js.map